import { Instagram, Facebook } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

interface SocialButtonProps {
  platform: 'instagram' | 'facebook';
  href: string;
}

const SocialButton = ({ platform, href }: SocialButtonProps) => {
  const { t } = useLanguage();
  
  const config = {
    instagram: {
      icon: Instagram,
      label: t.visitInstagram,
    },
    facebook: {
      icon: Facebook,
      label: t.visitFacebook,
    },
  };

  const { icon: Icon, label } = config[platform];

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`${label} (opens in new tab)`}
      className="group flex items-center gap-4 px-8 py-4 border border-primary/15 bg-transparent hover:bg-primary hover:border-primary transition-all duration-300 ease-out"
    >
      <Icon 
        className="w-5 h-5 text-primary group-hover:text-primary-foreground transition-colors duration-300" 
        strokeWidth={1.5}
        aria-hidden="true"
      />
      <span className="font-sans text-sm tracking-widest uppercase text-primary group-hover:text-primary-foreground transition-colors duration-300">
        {label}
      </span>
    </a>
  );
};

export default SocialButton;
